import {
  useGetAllEventsMutation,
  useGetAllGradesMutation,
  useSearchSchoolsMutation,
  useGetEventLevelsMutation,
  useGetUpcomingRoundsMutation,
  useCreateEventMutation,
  useDeleteEventMutation,
  useGetUserAgentsMutation,
  useGetPocDetailsGatewayMutation,
} from "./eventsMutation";

const useEventsQueries = () => {
  const [getAllEvents] = useGetAllEventsMutation();
  const [getAllGrades] = useGetAllGradesMutation();
  const [searchSchools] = useSearchSchoolsMutation();
  const [getEventLevels] = useGetEventLevelsMutation();
  const [getUpcomingRounds] = useGetUpcomingRoundsMutation();
  const [createEvent] = useCreateEventMutation();
  const [deleteEvent] = useDeleteEventMutation();
  const [getUserAgents] = useGetUserAgentsMutation();
  const [getPocDetailsGateway] = useGetPocDetailsGatewayMutation();

  const handleGetAllEvents = async (body) => {
    try {
      const events = await getAllEvents({ body }).unwrap();
      return events;
    } catch (error) {
      console.error("Error fetching all events", error);
    }
  };

  const handleGetAllGrades = async () => {
    try {
      const grades = await getAllGrades().unwrap();
      return grades;
    } catch (error) {
      console.error("Error fetching grades", error);
    }
  };

  const handleSearchSchools = async (searchedSchool) => {
    try {
      const schools = await searchSchools({ searchedSchool }).unwrap();
      return schools;
    } catch (error) {
      console.error("Error fetching schools", error);
    }
  };

  const handleGetEventLevels = async (eventName) => {
    try {
      const eventLevels = await getEventLevels({ eventName }).unwrap();
      return eventLevels;
    } catch (error) {
      console.error("Error fetching event levels for ", eventName);
    }
  };

  const handleGetUpcomingRounds = async (body) => {
    try {
      const upcomingRounds = await getUpcomingRounds({ body }).unwrap();
      return upcomingRounds;
    } catch (error) {
      console.error(
        "Error fetching upcoming rounds for event level ",
        body.level
      );
    }
  };

  const handleCreateEvent = async (body) => {
    try {
      const response = await createEvent({ body }).unwrap();
      return response;
    } catch (error) {
      console.error("Error creating event", error);
      return { error: error };
    }
  };

  const handleDeleteEvent = async (eventId) => {
    try {
      const response = await deleteEvent({ eventId }).unwrap();
      return response;
    } catch (error) {
      console.error("Error deleting event with id", eventId);
    }
  };

  const handleGetUserAgents = async (params = {}) => {
    try {
      const response = await getUserAgents(params).unwrap();
      return response;
    } catch (error) {
      console.error("Error fetching user agents", error);
      return {
        agents: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        limit: 10,
      };
    }
  };

  const handleGetPocDetailsGateway = async (crnId) => {
    try {
      const response = await getPocDetailsGateway({ crnId }).unwrap();
      return response;
    } catch (error) {
      console.error("Error fetching POC details for CRN id", crnId, error);
      return { poc_details: [] };
    }
  };

  return {
    handleGetAllEvents,
    handleGetAllGrades,
    handleSearchSchools,
    handleGetEventLevels,
    handleGetUpcomingRounds,
    handleCreateEvent,
    handleDeleteEvent,
    handleGetUserAgents,
    handleGetPocDetailsGateway,
  };
};

export default useEventsQueries;
